<div class="drawer-header border-bottom">
  <span class="title">Detalhes da instituição de ensino</span>
  <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer p-4">

  <div class="basic-info">
    <div class="avatar">
      <p-avatar
        *ngIf="!imageError && imagePreview; else defaultAvatar"
        [image]="$any(imagePreview)"
        shape="circle"
        size="xlarge"
        (onImageError)="imageError = true"
      />
      <ng-template #defaultAvatar>
        <p-avatar
          [label]="getInitials(profileEducationalInstitution?.nome)"
          [icon]="!profileEducationalInstitution?.nome ? 'pi pi-building' : undefined"
          shape="circle"
          size="xlarge"
        />
      </ng-template>
    </div>
    <div class="details">
      <div class="name-area">
        <div class="left-area">
          <div class="title-header">
            <span class="name">{{ profileEducationalInstitution?.nome }}</span>
            <div class="info">
              <span> <strong> {{profileEducationalInstitution?.sigla}} </strong></span>
              <span>•</span>
              <span> <p-tag *ngIf="profileEducationalInstitution?.isActive" severity="success" value="Activo" />
                <p-tag *ngIf="!profileEducationalInstitution?.isActive" severity="danger" value="Inactivo" /> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <p-splitbutton (onClick)="aprovarCandidatura()" label="Aprovar" [model]="items" /> -->
  </div>
  <div class="d-flex justify-content-between gap-3 mt-4">
    <div class="card-info w-50">
      <div class="icon">
        <i class="pi pi-building-columns"></i>
      </div>
      <div class="description">
        <span class="title">Tipo de instituição</span>
        <span class="info"> {{profileEducationalInstitution?.tipoInstituicaoEnsinoValueEnum | tipoInstituicao}} </span>
        <!-- <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
      </div>
    </div>
    <div class="card-info w-50">
      <div class="icon">
        <i class="pi pi-phone"></i>
      </div>
      <div class="description">
        <span class="title">Telefone da instituição</span>
        <span class="info mt-2"><strong> {{profileEducationalInstitution?.telefone}} </strong></span>
      </div>
    </div>
  </div>
  <div class="endereco">
    <div class="icon">
      <i class="pi pi-map-marker"></i>
    </div>
    <div class="description">
      <span class="info mt-2"><strong> {{profileEducationalInstitution?.endereco}},
          {{profileEducationalInstitution?.provincia}} </strong></span>
      <!--pi-map-marker <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
    </div>
  </div>
  <div class="site-url">
    <div class="icon">
      <i class="pi pi-envelope"></i>
    </div>
    <div class="description">
      <span class="info mt-2"><strong> {{profileEducationalInstitution?.email}} </strong></span>
      <!--pi-map-marker <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
    </div>
  </div>
  <div class="avatar-info">
    <div class="flex justify-center">
      <p-avatar-group>
        <p-avatar icon="pi pi-user" shape="circle" />
        <p-avatar icon="pi pi-user" shape="circle" />
        <p-avatar icon="pi pi-user" shape="circle" />
        <p-avatar label="+5" shape="circle" />
        <p>8 Candidaturas até o momento</p>
      </p-avatar-group>
    </div>
  </div>
  <div class="about">
    <h3 class="title">Categoria da institução</h3>
    <span><i class="pi pi-check"></i> {{profileEducationalInstitution?.categoriaInstituicaoEnsino}} </span>
    <h3 class="title">Natureza da instituição</h3>
    <span><i class="pi pi-check"></i> {{profileEducationalInstitution?.natureza}}</span>
    <h3 class="title">Sobre a instituição</h3>
    <p> {{profileEducationalInstitution?.descricaoEmpresa}} </p>
  </div>
  <!-- 
      <p-tabs value="0">
        <p-tablist>
          <p-tab value="0">
            <div class="tab-icon">
              <img src="icons/users-01.svg" alt="Email Icon" />
            </div>
            Candidato
          </p-tab>
          <p-tab value="1">
            <div class="tab-icon">
              <img src="icons/briefcase-02.svg" alt="Email Icon" />
            </div>
            Vaga
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
    
            <div class="d-flex gap-3 mt-4">
              <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                <i class="pi pi-user"></i>
              </div>
              <span>{{instituicaoSelected()?.profissional?.nome || instituicaoSelected()?.profissional ||
                candidaturaRequest?.profissional?.nome}}</span>
            </div>
            <div class="d-flex gap-3 mt-3">
              <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                <i class="pi pi-envelope"></i>
              </div>
              <span>{{instituicaoSelected()?.profissional?.email || candidaturaRequest?.profissional?.email}}</span>
            </div>
            <div class="d-flex gap-3 mt-3">
              <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                <i class="pi pi-phone"></i>
              </div>
              <span>{{instituicaoSelected()?.profissional?.telefonePrincipal ||
                candidaturaRequest?.profissional?.telefonePrincipal}} <div
                  *ngIf="candidaturaRequest?.profissional?.telefoneSecundario">
                  {{instituicaoSelected()?.profissional?.telefoneSecundario ||
                  candidaturaRequest?.profissional?.telefoneSecundario}}</div> </span>
            </div>
    
            <div class="about mt-4">
              <span class="title">Formação acadêmica</span>
              @for (item of listaHabilitacoes; track $index) {
              <div class="education-card mt-3">
                <div class="graduation-icon">
                  <img src="icons/graduation-grey.svg" alt="">
                </div>
                <div class="info">
                  <span class="course">{{item.designacao}}</span>
                  <span class="institution">{{item.instituicao}}</span>
                  <span class="period">{{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.dataFim |
                    date:'dd-MM-yyyy'}}</span>
                </div>
              </div>
              }
            </div>
    
            <div class="about mt-4">
              <span class="title">Histórico profissional</span>
              @for (item of listaExperiencias; track $index) {
              <div class="education-card mt-3">
                <div class="graduation-icon">
                  <img src="icons/award-01.svg" alt="">
                </div>
                <div class="info">
                  <span class="course">{{item.designacaoFuncao || '-'}}</span>
                  <span class="institution">{{item.nomeEmpresa || '-'}}</span>
                  <span class="period">
                    {{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.isActualEmprego ? "até ao momento." :
                    (item.dataFim | date:'dd-MM-yyyy')}}
                  </span>
                  -- <p>
                                    {{item.descricao}}
                                </p> --
                </div>
              </div>
              }
            </div>
    
            <div class="about mt-4">
              <span class="title">Sobre o candidato</span>
              <p>{{instituicaoSelected()?.profissional?.sobreMim || candidaturaRequest?.profissional?.sobreMim}}</p>
            </div>
    
          </p-tabpanel>
          <p-tabpanel value="1">
    
            <div class="d-flex gap-3 mt-4">
              <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                <i class="pi pi-calendar"></i>
              </div>
              <span>{{instituicaoSelected()?.vaga?.dataEncerramento || candidaturaRequest?.vaga?.dataEncerramento|
                date:'dd-MM-yyyy'}}</span>
            </div>
            <div class="d-flex gap-3 mt-3">
              <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                <i class="pi pi-briefcase"></i>
              </div>
              <span>{{instituicaoSelected()?.vaga?.modelo || candidaturaRequest?.vaga?.modelo}}</span>
            </div>
            <div class="d-flex gap-3 mt-3">
              <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                <i class="pi pi-map-marker"></i>
              </div>
              <span>{{instituicaoSelected()?.vaga?.localizacao || candidaturaRequest?.vaga?.localizacao}}</span>
            </div>
    
            <div class="about mt-4">
              <span class="title">Sobre a vaga</span>
              <p>{{instituicaoSelected()?.vaga?.descricao || candidaturaRequest?.vaga?.descricao}}</p>
            </div>
    
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>-->

</div>

<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>